import { FAQ } from '../types';

export default {
  state: {
    faqQuery: null,
  },
  getters: {},
  mutations: {
    [FAQ.SET_FAQ_QUERY](state, payload) {
      state.faqQuery = payload;
    },
  },
  actions: {},
};
